module.exports = __webpack_public_path__ + "files/3aeb34221ae0b24ef9e3c2f18a24c2e3.svg";